import { render, staticRenderFns } from "./ItemUpdated.vue?vue&type=template&id=df042f76"
import script from "./ItemUpdated.vue?vue&type=script&lang=js"
export * from "./ItemUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports